import classNames from "classnames";
import moment from "moment";
import React from "react";
import {
	TBallastBackendRecord,
	TBallastRecord,
} from "../../../../../redux/app/ballast/@types";
import { TBallast_Ballast } from "../../../../../redux/app/ballast/groups/ballast";
import CommaSeparator from "../../../../_common/CommaSeparator";
import BallastRecordParticipantsView from "../_elements/ParticipantsView";

import BallastTableRows from "../_elements/BallastTableRows";
import getSignTableRows from "../_elements/getSignTableRows";

import versions from "../../../../../redux/app/ballast/versions";

type OwnProps = {
	ballastRecord: TBallastRecord;
	isStrikedOff?: boolean;
};
type BallastOperationPreviewProps = OwnProps;
function BallastOperationPreview(props: BallastOperationPreviewProps) {
	const record = props.ballastRecord as TBallast_Ballast;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		{
			if (record.version === versions[0].value) {
				return (
					<BallastTableRows
						record={record}
						tableRows={[
							[operationDate, "A", "1", renderItem1()],
							[null, null, "2", renderItem2()],
							[null, null, "3", renderItem3()],
							[null, null, "4", renderItem4()],
							[null, null, "5", renderItem5()],
							[null, null, "6", renderItem6()],
							[null, null, "NOTE", record.remarks],
						]}
					/>
				);
			} else {
				return (
					<BallastTableRows
						record={record}
						tableRows={[
							[operationDate, null, "3.1.1", renderItem3P1P1()],
							[null, null, "3.1.2", renderItem3P1P2()],
							...renderUserInfoRows(),
							[operationDate, null, "3.2.1", renderItem3P2P1()],
							[null, null, "3.2.2", renderItem3P2P2()],
							[null, null, "3.2.3", renderItem3P2P3()],
							[null, null, "NOTE", record.remarks],
						]}
					/>
				);
			}
		}
	}

	// MEPC.369(80)
	function renderItem1() {
		const smtStartDate = record.tanks[0].startDate;
		const smtStartTime = record.tanks[0].startTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);

			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
							{record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at Lat{" "}
							{record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Start - {smtStartTime} hrs (UTC) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
							{record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {smtStartTime} hrs (UTC) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at Lat{" "}
							{record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
				</>
			);
		}
	}

	function renderItem2() {
		const smtEndDate = record.tanks[record.tanks.length - 1].endDate;
		const smtEndTime = record.tanks[record.tanks.length - 1].endTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtEndDate}T${smtEndTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
							{record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at Lat{" "}
							{record.placeOfBallast.endPosition.latitude}/ Long{" "}
							{record.placeOfBallast.endPosition.longitude}, at {record.depth}m
							minimum depth
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Completion - {record.tanks[record.tanks.length - 1].endTime} hrs
							(UTC) ({record.tanks[record.tanks.length - 1].endTime} SMT) on{" "}
							{moment(
								record.tanks[record.tanks.length - 1].endDate,
								"YYYY-MM-DD"
							).format("DD-MMM-YYYY")}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion - {record.tanks[record.tanks.length - 1].endTime} hrs
							(UTC) on{" "}
							{moment(
								record.tanks[record.tanks.length - 1].endDate,
								"YYYY-MM-DD"
							).format("DD-MMM-YYYY")}{" "}
							at Lat {record.placeOfBallast.endPosition.latitude}/ Long{" "}
							{record.placeOfBallast.endPosition.longitude}, at {record.depth}m
							minimum depth
						</>
					) : null}
				</>
			);
		}
	}

	function renderItem3() {
		let tankNames = "";
		record.tanks.forEach((tank, index) => {
			tankNames += tank.selectedTank.tankCode;
			if (index !== record.tanks.length - 1) {
				tankNames += ",";
			}
		});
		return tankNames;
	}

	function renderItem4() {
		// let accumulatedValue = 0;
		// accumulatedValue = record.tanks.reduce(
		//     (acc, curr) => acc + curr.newRetainedQuantity,
		//     0
		// );
		return (
			<h4 className="font-medium uppercase">
				Uptake {record.totalOperatedWaterVolume} M³. Final quantity retained:{" "}
				{record.ballastROB.toFixed(2)} M³
			</h4>
		);
	}

	function renderItem5() {
		return <h4 className="font-medium uppercase">{record.approvedBWMP}</h4>;
	}

	function renderItem6() {
		return <h4 className="font-medium uppercase">{record.treatmentMethod}</h4>;
	}

	// MEPC 70
	function renderItem3P1P1() {
		return validateAndPreviewPlaceAndPosition(record);
	}

	function renderItem3P1P2() {
		return (
			<h4 className="font-medium uppercase">
				Uptake: {record.totalOperatedWaterVolume} M³,
				{record.ballastROB
					? `Total Retained Quantity Onboard: ${record.ballastROB.toFixed(
							2
					  )} M³`
					: `Total Quantity Retained: ${totalQuantityRetained(record).toFixed(
							2
					  )} M³`}
			</h4>
		);
	}

	function renderUserInfoRows() {
		if (!record.isBallastWaterTreatmentPlanUsed) return [];
		return getSignTableRows(record as TBallastBackendRecord);
	}

	function renderItem3P2P1() {
		if (!record.isBallastWaterTreatmentPlanUsed) return null;
		return (
			<h4 className="font-medium uppercase">
				{validateAndPreviewPlaceAndPosition(record)}
			</h4>
		);
	}

	function renderItem3P2P2() {
		if (!record.isBallastWaterTreatmentPlanUsed) return null;
		return (
			<h4 className="font-medium uppercase">
				Treated: {record.totalOperatedWaterVolume} M³
			</h4>
		);
	}

	function renderItem3P2P3() {
		if (!record.isBallastWaterTreatmentPlanUsed) return null;
		return <h4 className="font-medium uppercase">YES (USING BWTP)</h4>;
	}

	const validateAndPreviewPlaceAndPosition = (
		ballastRecord: TBallast_Ballast
	) => {
		return (
			<>
				{ballastRecord.placeOfBallast.place === "IN_PORT" ? (
					<>
						{moment(ballastRecord.tanks[0].startDate, "YYYY-MM-DD").format(
							"DD-MMM-YYYY"
						)}{" "}
						{ballastRecord.tanks[0].startTime} to{" "}
						{moment(
							ballastRecord.tanks[ballastRecord.tanks.length - 1].endDate,
							"YYYY-MM-DD"
						).format("DD-MMM-YYYY")}{" "}
						{ballastRecord.tanks[ballastRecord.tanks.length - 1].endTime},{" "}
						{ballastRecord.placeOfBallast.portName}
					</>
				) : null}
				{ballastRecord.placeOfBallast.place === "AT_SEA" ? (
					<>
						{moment(ballastRecord.tanks[0].startDate, "YYYY-MM-DD").format(
							"DD-MMM-YYYY"
						)}{" "}
						{ballastRecord.tanks[0].startTime}{" "}
						{ballastRecord.placeOfBallast.startPosition.latitude},{" "}
						{ballastRecord.placeOfBallast.startPosition.longitude}, to{" "}
						{moment(
							ballastRecord.tanks[ballastRecord.tanks.length - 1].endDate,
							"YYYY-MM-DD"
						).format("DD-MMM-YYYY")}{" "}
						{ballastRecord.tanks[ballastRecord.tanks.length - 1].endTime},{" "}
						{ballastRecord.placeOfBallast.endPosition.latitude},{" "}
						{ballastRecord.placeOfBallast.endPosition.longitude}, DEPTH:{" "}
						{ballastRecord.depth}M
					</>
				) : null}
			</>
		);
	};

	const totalQuantityRetained = (ballastRecord: TBallast_Ballast) => {
		let accumulatedValue = 0;
		if (ballastRecord.ballastROB) {
			accumulatedValue = ballastRecord.tanks.reduce(
				(acc, curr) => acc + curr.newRetainedQuantity,
				0
			);
		} else {
			accumulatedValue = ballastRecord.tanks.reduce(
				(acc, curr) =>
					acc + curr.selectedTank.expectedQuantity + curr.transferQuantity,
				0
			);
		}
		return accumulatedValue;
	};

	return renderMain();
}

export default BallastOperationPreview;
